bz_app.directive('noHeaderMap', function () {
  return {
    restrict: 'AE',
    link: function (scope) {
      scope.$emit('property-header-map-loaded')
    },
  }
})
